import "./ClientDashboard.module.css";
import Header from "@/reusable_sections/Header";
import SupportAssistance from "./sections/SupportAssistance";
import Footer from "@/reusable_sections/Footer";
export default function ClientDashboardPage() {
  return <div>
      <Header />
      <section className="bg-[#050A10] py-24">
        <div className="container mx-auto px-4">
          [imperium_dashboard]
        </div>
      </section>
      <SupportAssistance />
      <Footer />
    </div>;
}